import { useState, useEffect, useCallback } from 'react';
import type { RefObject } from 'react';

interface ContainerSize {
  readonly width: number;
  readonly height: number;
}

export function useContainerSize(ref: RefObject<HTMLDivElement | null>): ContainerSize {
  const [size, setSize] = useState<ContainerSize>({ width: 0, height: 0 });

  const updateSize = useCallback(() => {
    if (ref.current) {
      setSize({
        width: ref.current.clientWidth,
        height: ref.current.clientHeight,
      });
    }
  }, [ref]);

  useEffect(() => {
    updateSize();

    const observer = new ResizeObserver(updateSize);
    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => observer.disconnect();
  }, [ref, updateSize]);

  return size;
}
